import { render, staticRenderFns } from "./SitesBiulder.vue?vue&type=template&id=6a8bf000&scoped=true"
import script from "./SitesBiulder.vue?vue&type=script&lang=js"
export * from "./SitesBiulder.vue?vue&type=script&lang=js"
import style0 from "./SitesBiulder.vue?vue&type=style&index=0&id=6a8bf000&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a8bf000",
  null
  
)

export default component.exports